"use strict";
/**
 * @module Services.FetchQuery
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Server result from a FETCH_QUERY request.
 */
var FetchQueryResult = /** @class */ (function () {
    /**
     * Create a new FetchQueryResult instance
     *
     * @param properties  the topic specification properties
     * @param results  the topics that have been fetched
     * @param hasMore  s flag indicating that there are more topics that can be fetched
     */
    function FetchQueryResult(properties, results, hasMore) {
        this.properties = properties;
        this.results = results;
        this.hasMore = hasMore;
    }
    return FetchQueryResult;
}());
exports.FetchQueryResult = FetchQueryResult;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/fetch-query/fetch-query-result.js
// module id = 1299
// module chunks = 1